export const artistesData = [
  {
    name: "Crispin Berry",
    avatar: "./avatars/crispin.svg",
    price: "234.6",
  },
  {
    name: "Wade Warren",
    avatar: "./avatars/wade.svg",
    price: "234.6",
  },
  {
    name: "Robert Fox",
    avatar: "./avatars/robert.svg",
    price: "234.6",
  },
  {
    name: "Jacob Jones",
    avatar: "./avatars/jacob.svg",
    price: "234.6",
  },
  {
    name: "Ralph Edwards",
    avatar: "./avatars/ralph.svg",
    price: "234.6",
  },
  {
    name: "Arlene McCoy",
    avatar: "./avatars/arlene.svg",
    price: "234.6",
  },
];
